import React, { Component } from 'react'

export default class FullScreeenSpinner extends Component {

	exit = (e) => {
		e.preventDefault();
		e.stopPropagation();
	}

	render() {
		return (
			<div className="full-screen" onClick={this.exit} >
				<h3><i className="fas fa-spinner"></i></h3>
			</div>

		)
	}
}